class Phone {
  constructor(params) {
    this.number = params.number;
    this.id = params.id;
    this.type = params.type;
  }
}

export { Phone };



// WEBPACK FOOTER //
// ./src/models/Phone.js